'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _default_order = require('./default_order');

var _default_order2 = _interopRequireDefault(_default_order);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var byColumn = function byColumn(_ref) {
  var sortingColumns = _ref.sortingColumns;
  var _ref$sortingOrder = _ref.sortingOrder;
  var sortingOrder = _ref$sortingOrder === undefined ? _default_order2.default : _ref$sortingOrder;
  var _ref$selectedColumn = _ref.selectedColumn;
  var selectedColumn = _ref$selectedColumn === undefined ? -1 : _ref$selectedColumn;

  var sort = sortingOrder.FIRST;

  if (selectedColumn < 0) {
    return sortingColumns;
  }

  if (sortingColumns && {}.hasOwnProperty.call(sortingColumns, selectedColumn)) {
    sort = sortingOrder[sortingColumns[selectedColumn].direction];

    if (!sort) {
      return {};
    }
  }

  return _defineProperty({}, selectedColumn, {
    direction: sort,
    position: 0
  });
};

exports.default = byColumn;


//////////////////
// WEBPACK FOOTER
// ./~/reactabular-sort/dist/by_column.js
// module id = 1406
// module chunks = 0